// prod.env.js
module.exports = {
    NODE_ENV: 'production',
    VUE_APP_API: 'https://tapadmin.cloudstaff.com',
    VUE_THEME_URL: 'https://static.prod.cloud.cloudstaff.com',
    VUE_APP_ENVIRONMENT: 'prod',
    VUE_APP_UBERAPI: 'https://api-ubertickets.cloudstaff.com',
    VUE_APP_MAPS: 'AIzaSyB22dqBx_4mcnLY5fg4zAvfl2rzAezBvdc',
    VUE_APP_GOOGLE_CLIENT_ID: '664701702770-opcvplgmjqg0g27aolpuqne3tqju5ond.apps.googleusercontent.com',
    VUE_APP_APPLE_BUNDLE_ID: 'com.cloudstaff.tap',
    VUE_APP_AZURE_CLIENT_ID: 'bc63b190-c82a-4255-9b11-1b5cf69f73cb',
    VUE_APP_AZURE_TENANT_ID: 'f2d95c07-9a27-4022-b640-1724f9e26774',
};